import React, { useState } from 'react';
import CardContainer from './styles';
import PropTypes from 'prop-types';
import { Typography, Chip } from '@material-ui/core';
import LabelTitle from '../../Titles/LabelTitle';

const ProgramCard = ({ image, title, description, tag }) => {
	const [visible, setVisible] = useState(true);

	return (
		<CardContainer image={image}>
			{tag ? <Chip label={tag} /> : ''}
			<div
				className={`container-image ${!visible ? 'image-visible' : ''}`}
				onMouseOver={() => setVisible(false)}
				onMouseLeave={() => setVisible(true)}
			/>
			<div className={`content-card ${!visible ? 'content-invisible' : ''}`}>
				<LabelTitle content={title} />
				<Typography color="textSecondary" className="description-card" variant="h4">
					{description}
				</Typography>
			</div>
		</CardContainer>
	);
};

export default ProgramCard;

ProgramCard.propTypes = {
	image: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	tag: PropTypes.string
};
